<template>
  <div class="manager-vacation">
    <div>
      <PageTitle
        isBack="true"
        link="rh"
        fontSize="25"
        icon="fa fa-sun-o"
        title="Recursos Humanos // Gerenciamento de férias"
      />
    </div>
    <!-- filtros da lista -->
    <div class="container-vacation">
      <header>
        <div class="search-box">
          <span>Nome</span>
          <vs-input @input="inputSearchName" icon="search" v-model="name" style="width: 100%" />
          <div v-if="searchBox">
            <vs-list class="search-selected-vacation">
              <div class="close-box" @click="clickCloseBox">X</div>
              <vs-list-item
                v-for="(person, index) in employeeData"
                :key="index"
                class="item-selected"
                :title="person.nome"
              >
                <vs-button color="success" @click="clickFunc(person)" icon="add_box"></vs-button>
              </vs-list-item>
            </vs-list>
          </div>
        </div>
        <div class="box-item">
          <span>Status</span>
          <b-form-select
            style="width: 180px"
            icon="arrow_downward"
            :options="dataStatus"
            v-model="status"
            @input="eventSelectedStatus"
          ></b-form-select>
        </div>
        <div class="box-item">
          <span>Data</span>
          <input type="date" required pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" v-model="date" />
        </div>
        <div class="search-box">
          <span>Departamento</span>
          <vs-input
            icon="search"
            v-model="department"
            @input="inputSearcDepartment"
            style="width: 100%"
          />
          <div v-if="searchBoxDepartment">
            <vs-list class="search-selected-vacation">
              <div class="close-box" @click="clickCloseBox">X</div>
              <vs-list-item
                v-for="(depart, index) in departmentData"
                :key="index"
                class="item-selected"
                :title="depart.qbDescric"
              >
                <vs-button color="success" @click="clickDepart(depart)" icon="add_box"></vs-button>
              </vs-list-item>
            </vs-list>
          </div>
        </div>
        <div class="box-item">
          <span>Dia da Semana</span>
          <b-form-select
            id="selectedDayWeek"
            @input="changeWeek"
            style="width: 180px"
            :options="weeks"
            v-model="selectedWeek"
          ></b-form-select>
        </div>
        <button class="btn-serach-vacation" @click="clickSearch">Pesquisar</button>
      </header>
      <!-- fim -->
      <!-- lista de colaboradores -->
      <div class="table-collaborator-vacation">
        <div class="header-table-vacation">
          <div>
            <h4>Colaboradores:</h4>
            <button
              @click="clickImportRequestVacation"
              v-show="status == 'PendenteRH'"
            >Importar Solicitação de Férias...</button>
          </div>
          <h4>Total: {{vacationData.length}}</h4>
        </div>
        <table>
          <tr>
            <th class="area-check" v-if="status == 'PendenteRH'">
              <input class="check-custom" v-model="checkAll" type="checkbox" />
            </th>
            <th>
              <b>Matrícula</b>
            </th>
            <th>
              <b>Nome</b>
            </th>
            <th>
              <b>Período Aquisitivo</b>
            </th>
            <th>
              <b>Data Limite</b>
            </th>
            <th style="text-align: center;">
              <b>1&#186; Período Férias</b>
            </th>
            <th style="text-align: center;">
              <b>1&#186; Dia(s)</b>
            </th>
            <th style="text-align: center;">
              <b>2&#186; Período Férias</b>
            </th>
            <th style="text-align: center;">
              <b>2&#186; Dia(s)</b>
            </th>
            <th>
              <b>Departamento</b>
            </th>
            <th>
              <b>Gestor</b>
            </th>
            <th style="text-align: center;">
              <b>Venda Férias</b>
            </th>
            
            <th style="text-align: center;" v-if="status != 'NaoAprovados'">
              <b>Processado</b>
            </th>
            <th style="text-align: center;" v-else>
              <b>Não Aprovado</b>
            </th>

            <th style="text-align: center;" v-if="status == 'PendenteRH'">
              <b>Ação</b>
            </th>
          </tr>
          <tr v-for="(vacation, index) in vacationData" :key="index">
            <td class="area-check" v-if="status == 'PendenteRH'">
              <input class="check-custom" type="checkbox" v-model="vacation.check" />
            </td>
            <td>{{vacation.matricula}}</td>
            <td>{{vacation.name}}</td>
            <td>{{vacation.periodReceive}}</td>
            <td style="text-align: center;">{{vacation.dateVacationLimit}}</td>
            <td style="text-align: center;">{{vacation.dateVacationPeriod1}} - {{vacation.endDate1}}</td>
            <td style="text-align: center;">{{vacation.daysVacationPeriod1}}</td>
            <td>{{vacation.dateVacationPeriod2}} - {{vacation.endDate2}}</td>
            <td style="text-align: center;">{{vacation.daysVacationPeriod2}}</td>
            <td>{{vacation.department}}</td>
            <td>{{vacation.boss}}</td>
            <td style="text-align: center;">
              <div class="chip-aponta-yes" v-if="vacation.sellDaysVacation != null">
                <span>SIM</span>
              </div>
              <div class="chip-aponta-no" v-else>
                <span>NÃO</span>
              </div>
            </td>

            <td style="text-align: center;" v-if="status != 'NaoAprovados'">
              <div class="chip-aponta-yes" v-if="vacation.imported == 1">
                <span>SIM</span>
              </div>
              <div class="chip-aponta-no" v-else>
                <span>NÃO</span>
              </div>
            </td>
            <td style="text-align: center;" v-else>
              <div>
                <div v-if="vacation.status == 'Indeferido'">
                  <span>Gestor</span>
                </div>
                <div v-else>
                  <span>RH</span>
                </div>
              </div>
            </td>

            <td style="text-align: center;" v-if="status == 'PendenteRH'">
              <button class="btn-reject-vacation" @click="clickDiscarte(vacation)">Rejeitar</button>
            </td>
          </tr>
        </table>
      </div>
      <!-- fim -->

      <!-- poupap para descartar -->
      <vs-popup title="Deseja realmente rejeitar esse pedido de férias?" :active.sync="popupActivo">
        <div>
          <vs-textarea label="Digite um motivo" v-model="textReason" />
          <div>
            <vs-button color="success" @click="clickYesDiscarte" type="filled">Sim</vs-button>
            <vs-button color="danger" @click="clickNoDiscarte" type="filled">Não</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { baseApiUrlRH } from "@/global";
import { EventBusExpenses } from "@/eventBus/eventBusExpenses";

import PageTitle from "@/components/template/PageTitle";
//configuração das mensagens
const configMessage = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "error",
  duration: 5000
};

const configMessageYes = {
  iconPack: "fontawesome",
  position: "top-center",
  className: ["toast-global"],
  type: "success",
  duration: 3000
};

export default {
  name: "ManagerVacation",
  components: { PageTitle },
  data() {
    return {
      name: null,
      selectedIdEmployee: null,
      selectedDepartmentEmployee: null,
      status: "PendenteRH",
      date: null,
      department: null,
      loading: false,
      employeeData: [],
      departmentData: [],
      dataStatus: [
        { text: "Pendente RH", value: "PendenteRH" },
        { text: "Pendente Gestor", value: "PendenteGestor" },
        { text: "Processados", value: "Processados" },
        { text: "Não Aprovados", value: "NaoAprovados" }
      ],
      vacationData: [],
      searchBox: false,
      searchBoxDepartment: false,
      popupActivo: false,
      selectedVacation: null,
      textReason: null,
      selectedWeek: null,
      weeks: [
        { text: "Segunda-Feira", value: "Monday" },
        { text: "Terça-Feira", value: "Tuesday" },
        { text: "Quarta-Feira", value: "Wednesday" },
        { text: "Quinta-Feira", value: "Thursday" },
        { text: "Sexta-Feira", value: "Friday" },
        { text: "Sábado", value: "Saturday" },
        { text: "Domingo", value: "Sunday" }
      ],
      checkAll: null
    };
  },

  methods: {
    async inputSearchName() {
      this.selectedIdEmployee = '';
      this.searchBox = true;
      await axios
        .get(`${baseApiUrlRH}/employee/byName/${this.name}`)
        .then(resp => {
          this.employeeData = resp.data;
        });
      if (this.employeeData.length <= 0) {
        this.searchBox = false;
      }
    },
    async inputSearcDepartment() {
      this.selectedDepartmentEmployee = '';
      this.searchBoxDepartment = true;
      await axios
        .get(`${baseApiUrlRH}/employee/byDepartmentName/${this.department}`)
        .then(resp => {
          this.departmentData = resp.data;
        });
      if (this.departmentData.length <= 0) {
        this.searchBoxDepartment = false;
      }
    },
    clickFunc(person) {
      this.selectedIdEmployee = person.matricula;
      this.name = person.nome;
      this.searchBox = false;
    },
    clickDepart(depart) {
      this.selectedDepartmentEmployee = depart.qbDepto;
      this.department = depart.qbDescric;
      this.searchBoxDepartment = false;
    },
    // carrega lista de justificativas
    async searchEmployee(filter) {
      this.$vs.loading({ text: "Carregando lista..." });
      await axios
        .post(`${baseApiUrlRH}/vacation/search`, filter)
        .then(resp => {
          this.vacationData = resp.data;
          console.log(this.vacationData);
        })
        .catch(error => {
          this.$toasted.show(
            "Estamos com problema na conexão, por favor tente mais tarde!",
            configMessage
          );
        });
      this.$vs.loading.close();
    },
    eventSelectedStatus() {
      this.clickSearch();
    },
    async clickSearch() {
      const filter = {
        matricula: this.selectedIdEmployee == "" ? null : this.selectedIdEmployee,
        status: this.status,
        date: this.date == "" ? null : this.date,
        departmentId:
          this.selectedDepartmentEmployee == ""
            ? null
            : this.selectedDepartmentEmployee,
        weekDay: this.selectedWeek
      };
      
      await this.searchEmployee(filter);
    },
    async clickImportRequestVacation() {
      let listSelected = this.vacationData.filter(va => va.check === true);

      if (listSelected.length <= 0) {
        this.$toasted.show(
          "Selecione ao menos um pedido de férias para importar!",
          configMessage
        );
        return;
      }

      const requestVacation = {
        listVacation: listSelected,
        personRegistration: sessionStorage.getItem("@matricula")
      };

      this.$vs.loading({ text: "Importando férias..." });
      await axios
        .post(`${baseApiUrlRH}/vacation/import`, requestVacation)
        .then(resp => {
          this.$toasted.show(resp.data.message, configMessageYes);
          this.listStartVacationPage();
        })
        .catch(error => {
          this.$toasted.show(
            "Não foi possível importar as férias, possivelmente estamos com problemas de conexão, tente mais tarde!",
            configMessage
          );
          this.$vs.loading.close();
        });
      this.$vs.loading.close();
    },
    async clickYesDiscarte() {
      if (
        this.textReason == null ||
        this.textReason == "" ||
        this.textReason.trim().length == 0
      ) {
        this.$toasted.show(
          "Digite o motivo com no mínimo de 10 caracteres para rejeitar a solicitação de férias!",
          configMessage
        );
        return;
      }

      const discart = {
        requestVacationId: this.selectedVacation.vacationId,
        reason: this.textReason
      };

      this.$vs.loading({ text: "rejeitando férias..." });
      await axios
        .post(`${baseApiUrlRH}/vacation/discart`, discart)
        .then(resp => {
          this.popupActivo = false;
          this.listStartVacationPage();
          this.$toasted.show(resp.data.message, configMessageYes);
        })
        .catch(error => {
          this.$toasted.show(
            "Não foi possível rejeitar a solicitação de férias, possivelmente estamos com problemas de conexão, tente mais tarde!",
            configMessage
          );
          this.$vs.loading.close();
        });
      this.$vs.loading.close();
    },
    clickNoDiscarte() {
      this.popupActivo = false;
    },

    clickCloseBox() {
      this.searchBox = false;
      this.searchBoxDepartment = false;
    },
    clickDiscarte(requestVacation) {
      this.selectedVacation = requestVacation;
      this.textReason = null;
      this.popupActivo = true;
    },
    listStartVacationPage() {
      // filtro da pesquisa
      const filter = {
        matricula: null,
        status: "PendenteRH",
        date: null,
        departmentId: null,
        weekDay: null
      };

      this.searchEmployee(filter);
    },
    changeWeek() {
      const filter = {
        matricula: null,
        status: this.status,
        date: null,
        departmentId: null,
        weekDay: this.selectedWeek
      };

      this.searchEmployee(filter);
    },
    checkVacationList(checkItens) {
      this.vacationData.forEach(va => {
        va.check = checkItens;
      });
    }
  },
  watch: {
    checkAll() {
      this.checkVacationList(this.checkAll);
    }
  },
  mounted() {
    this.listStartVacationPage();
  }
};
</script>

<style scoped src="./style.css">
</style>
